import React, { useState } from 'react';
import { Grid, Box, Typography, CircularProgress } from '@mui/material';
import Calendar from './widgets/Calendar';
import MessageActivation from './widgets/MessageActivation';
import ReplyRate from './widgets/ReplyRate';
import MeaningfulConversations from './widgets/MeaningfulConversations';
import TimeToFirstConnection from './widgets/TimeToFirstConnection';
import ConnectionJourney from './widgets/ConnectionJourney';
// import DropOffPoints from './widgets/DropOffPoints';
import RetentionRate from './widgets/RetentionRate';
import EventFunnel from './widgets/EventFunnel';
// import Monetisation from './widgets/Monetisation';
import Onboarding from './widgets/Onboarding';
import VettedCommunityFunnel from './widgets/VettedCommunityFunnel';
import VettingJourney from './widgets/VettingJourney';
import { useDashboardMetricsQuery } from '../../api/use-dashboard-metrics-query';
import ActiveUsers from './widgets/ActiveUsers';
import { PortalPageHeader } from '../layout/PortalPageHeader';
import { portalDashboardCardSx } from '../../styles/portalSurfaces';

const getDefaultDateRange = () => {
  const endDate = new Date();
  const startDate = new Date();
  startDate.setDate(endDate.getDate() - 7);
  return [startDate, endDate];
};

const Dashboard = () => {
  const [dateRange, setDateRange] = useState(getDefaultDateRange);
  const [startDate, endDate] = dateRange;

  const { data: dashboardMetrics = null, isLoading: isLoadingMetrics } = useDashboardMetricsQuery(
    startDate,
    endDate,
  );

  return (
    <Box sx={{ height: '100%', display: 'flex', flexDirection: 'column' }}>
      <PortalPageHeader title="Social Loop Health" />
      <Box
        sx={{
          display: 'flex',
          flexWrap: 'wrap',
          alignItems: 'center',
          justifyContent: 'flex-end',
          gap: 2,
          mb: 2,
        }}
      >
        <Box sx={{ width: { xs: '100%', sm: 'auto' }, flexShrink: 0 }}>
          <Calendar startDate={startDate} endDate={endDate} onDateRangeChange={setDateRange} />
        </Box>
      </Box>

      {isLoadingMetrics && (
        <Box sx={{ display: 'flex', alignItems: 'center', gap: 1.25, mb: 2 }}>
          <CircularProgress size={18} color="primary" />
          <Typography variant="body2" color="text.secondary">
            Loading dashboard metrics...
          </Typography>
        </Box>
      )}

      <Grid container spacing={3} sx={{ flexGrow: 1, overflow: 'auto' }}>
        <Grid item xs={12}>
          <Box
            sx={{
              display: 'grid',
              gridTemplateColumns: {
                xs: '1fr',
                sm: 'repeat(2, minmax(0, 1fr))',
                md: 'repeat(5, minmax(0, 1fr))',
              },
              gap: 3,
            }}
          >
            <Box sx={portalDashboardCardSx}>
              <MessageActivation metrics={dashboardMetrics} />
            </Box>
            <Box sx={portalDashboardCardSx}>
              <ReplyRate metrics={dashboardMetrics} />
            </Box>
            <Box sx={portalDashboardCardSx}>
              <MeaningfulConversations metrics={dashboardMetrics} />
            </Box>
            <Box sx={portalDashboardCardSx}>
              <TimeToFirstConnection metrics={dashboardMetrics} />
            </Box>
            <Box sx={portalDashboardCardSx}>
              <ActiveUsers metrics={dashboardMetrics} />
            </Box>
          </Box>
        </Grid>

        <Grid item xs={12} md={6}>
          <Box sx={portalDashboardCardSx}>
            <ConnectionJourney metrics={dashboardMetrics} />
          </Box>
        </Grid>

        {/* <Grid item xs={12} md={6}>
          <Box sx={portalDashboardCardSx}>
            <DropOffPoints metrics={dashboardMetrics} />
          </Box>
        </Grid> */}
        <Grid item xs={12} md={6}>
          <Box sx={portalDashboardCardSx}>
            <RetentionRate metrics={dashboardMetrics} />
          </Box>
        </Grid>

        <Grid item xs={12} md={6}>
          <Box sx={portalDashboardCardSx}>
            <Onboarding metrics={dashboardMetrics} />
          </Box>
        </Grid>

        {/* <Grid item xs={12} md={6}>
          <Box sx={portalDashboardCardSx}>
            <RetentionRate metrics={dashboardMetrics} />
          </Box>
        </Grid> */}

        <Grid item xs={12} md={6}>
          <Box sx={portalDashboardCardSx}>
            <EventFunnel metrics={dashboardMetrics} />
          </Box>
        </Grid>
        {/* 
        <Grid item xs={12} md={6}>
          <Box sx={portalDashboardCardSx}>
            <Monetisation metrics={dashboardMetrics} />
          </Box>
        </Grid> */}

        <Grid item xs={12}>
          <VettedCommunityFunnel metrics={dashboardMetrics} />
        </Grid>

        <Grid item xs={8}>
          <Box sx={portalDashboardCardSx}>
            <VettingJourney metrics={dashboardMetrics} />
          </Box>
        </Grid>
      </Grid>
    </Box>
  );
};

export default Dashboard;
